module.exports = __webpack_public_path__ + "img/blocktrac.28f73ad1.png";